import React from 'react';
import { Step, StepType } from '../../chat/types/base_step';
import { QuestionAnswers } from '../../helpers/questions.helper';
import Form from './question_components/form';
import OptionsSelection from './question_components/options_selection';

export default function loadByQuestionType(
  currentStep: Step,
  handleSubmit: (questionAnswers: QuestionAnswers[]) => void,
  answers: Record<string, any>,
  isStartSubmitted: boolean
) {
  switch (currentStep.type) {
    case StepType.Radio:
      return (
        <OptionsSelection
          currentStep={currentStep}
          handleSubmit={handleSubmit}
          answers={answers}
        />
      );
    case StepType.Form:
      return (
        <Form
          currentStep={currentStep}
          handleSubmit={handleSubmit}
          answers={answers}
          isStartSubmitted={isStartSubmitted}
        />
      );
    default:
      return null;
  }
}
